<template>
    <div class="settlement" >
<!--        <el-card class="noprint">-->
<!--            <el-page-header @back="goBack" content="采购订单详情"></el-page-header>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <div ref="tablePosition"></div>
                <el-table
                    size="mini"
                    stripe
                    :data="tableData"
                    v-loading="loading"
                    @selection-change="handleSelectionChange"
                    :height="tableConfig.height"
                    style="width: 100%">
                    <!-- <el-table-column type="selection" width="55" fixed/> -->
                    <el-table-column width="auto" prop="name" label="商品名称" min-width="160"></el-table-column>
                    <el-table-column width="auto" prop="model" label="型号" :min-width="160"></el-table-column>
                    <el-table-column width="auto" prop="num" label="数量" :min-width="80" align="right"></el-table-column>
                    <el-table-column width="auto" prop="untaxedPrice" label="未税单价(元)" :min-width="120" align="right"></el-table-column>
                    <el-table-column width="auto" prop="untaxedTotalPrice" label="未税总价(元)" :min-width="120" align="right"></el-table-column>
                    <el-table-column width="auto" prop="price" label="含税单价(元)" :min-width="120" align="right"></el-table-column>
                    <el-table-column width="auto" prop="totalPrice" label="含税总价(元)" :min-width="120" align="right"></el-table-column>
                    <el-table-column width="auto" prop="orderMemo" label="备注" :min-width="120"></el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px" v-if="total > 0">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        @size-change="onSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
    </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {

    data() {
        return {
            pageLoading: undefined,
            id: "",
            tableConfig: {
                height: 0,
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
        }
    },
    methods: {
        onSearch() {
            const that = this;
            this.loading = true;
            this.$axios.get("/admin/purchaseOrder/detail/" + this.id)
            .then(function(response) {
                let resp = response.data;
                if( resp.header.status == 0) {
                    that.tableData = resp.data;
                }
            }).finally(() => {
                that.loading = false;
            });
        },
        goBack() {
            this.$router.go(-1);
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        },
    },
    mounted() {
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 300);
    },
    created() {
        window.addEventListener("resize", this.setTableHeight);
        let paramsStore;
        const params = sessionStorage.getItem("params");
        if(params) {
            paramsStore = JSON.parse(params);
        }
        const { id } = JSON.stringify(this.$route.params)== "{}"?paramsStore:this.$route.params;
        this.id = id;
        this.onSearch();
    },
    beforeDestroy() {
        if(this.pageLoading) {
            this.pageLoading.close();
            this.pageLoading = undefined;
        }
    }
}
</script>
<style>

    .item {

        margin-bottom: 0px;

    }
    .item1 {
        margin-top: -10px;
        margin-bottom: 0px;

    }
</style>